import React, { useState } from "react";
import { Field, reduxForm, SubmissionError, getFormValues } from "redux-form";
import {
  checkIfEmpty,
  validate
} from "@components/validation/changePasswordForm";
import { trimString } from "@utils";
import { resetPasswordAccount } from "@actions/password";
import { defaultAction } from "@actions/defaultAction";
import RenderFormFieldNew from "@components/forms/RenderFormFieldNew";
import styled from "@emotion/styled";
import loadable from "@loadable/component";
const PassSpecContainer = loadable(() =>
  import(
    /* webpackChunkName: "PassSpecContainer" */ "../components/forms/PassSpecContainer"
  )
);
import { validatePassword, anyValue } from "@components/validation";
const MessageContainer = loadable(() =>
  import(/* webpackChunkName: "MessageContainer" */ "./MessageContainer")
);
import SmallButtonSpinner from "@components/SmallButtonSpinner";
import CustomSubmitButton from "./CustomSubmitButton";
import { PASSWORD_MODAL_OPEN } from "@constants/actionTypes";
import { useDispatch, useSelector } from "react-redux";

const InputWrapper = styled.div`
  position: relative;
  margin-bottom: 18px;
`;

const ButtonWrapper = styled.div`
  margin-top: 20px;
`;

const ChangePasswordForm = ({ handleSubmit, invalid }) => {
  const dispatch = useDispatch();
  const formData = useSelector(state => getFormValues("changePassword")(state));
  const [submitText, setSubmitText] = useState("Submit");
  const [submitButton, setSubmitButton] = useState("ORANGE_BUTTON");
  const [loading, setLoadSpinner] = useState(false);
  const [errorFromServer, setErrorFromServer] = useState(null);

  const submit = async fields => {
    if (loading) return;
    const response = checkIfEmpty(fields);

    if (Object.keys(response).length) {
      throw new SubmissionError(response);
    }
    setLoadSpinner(true);
    const serverResponse = await dispatch(
      resetPasswordAccount(
        trimString(fields.newPassword),
        trimString(fields.oldPassword)
      )
    );

    setLoadSpinner(false);
    if (serverResponse === "success") {
      setSubmitText("Success");
      setSubmitButton("GREEN_BUTTON");
      setTimeout(() => {
        dispatch(defaultAction(PASSWORD_MODAL_OPEN, false));
      }, 3000);
    } else if (serverResponse?.error) {
      setErrorFromServer(serverResponse.error);
    }
  };

  return (
    <form onSubmit={handleSubmit(submit)}>
      {errorFromServer && (
        <div>
          <MessageContainer
            message={errorFromServer}
            classes={"credit-card-form-error-message"}
          />
        </div>
      )}
      <InputWrapper>
        <Field
          name="oldPassword"
          component={RenderFormFieldNew}
          type="password"
          placeholder="Old Password"
          validate={anyValue}
          autoComplete="off"
        />
      </InputWrapper>
      <InputWrapper>
        <Field
          name="newPassword"
          component={RenderFormFieldNew}
          type="password"
          placeholder="New Password"
          validate={validatePassword}
          autoComplete="new-password"
        />
      </InputWrapper>
      <PassSpecContainer
        password={formData?.newPassword || ""}
        marginBottom={"20px"}
      />
      <InputWrapper>
        <Field
          name="reenterNewPassword"
          component={RenderFormFieldNew}
          type="password"
          placeholder="Re-enter New Password"
          validate={validatePassword}
          autoComplete="new-password"
        />
      </InputWrapper>
      <ButtonWrapper>
        <CustomSubmitButton
          type="submit"
          styles={{ height: "72px", borderRadius: "36px" }}
          buttonType={submitButton}
          disabled={invalid}
          disabledBackGroundColor={"rgba(119, 121, 132, 0.48)"}
        >
          {loading ? (
            <SmallButtonSpinner img="https://cdn.cardcash.com/website/ui/elements/spinner-white.png" />
          ) : (
            <span>{submitText}</span>
          )}
        </CustomSubmitButton>
      </ButtonWrapper>
    </form>
  );
};

export default reduxForm({
  form: "changePassword",
  validate,
  enableReinitialize: true
})(ChangePasswordForm);
